import { VerticalDivider } from '../../atoms/vertical-divider/VerticalDivider';
import { TopNavigationItem } from '../top-navigation-item/TopNavigationItem';
import styles from './top-navigation-bar.module.scss';
import { NavMenuPages } from 'modules/app/types/navigation-menu.type';

type NavigationBarMenuProps = {
  className?: string;
  items?: NavMenuPages;
};

export const TopNavigationBar = ({ items, className }: NavigationBarMenuProps) => {
  const displaySubPagesDivider = () => {
    return (items?.subPages.filter((entry) => entry.enabled).length ?? 0) > 0;
  };

  return (
    <div className={className}>
      <div className={styles.menu}>
        {items?.mainPages
          .filter((entry) => entry.enabled)
          .map((entry) => (
            <TopNavigationItem entry={entry} key={entry.route} />
          ))}
        {displaySubPagesDivider() && <VerticalDivider />}
        {items?.subPages
          .filter((entry) => entry.enabled)
          .map((entry) => (
            <TopNavigationItem entry={entry} key={entry.route} />
          ))}
      </div>
    </div>
  );
};
